import { Box } from "@mui/material"

import { Dashboard } from "../index";

export const Procurement = () => {
    return (
        <Box height={'100%'} display={'flex'} flexDirection={'column'} p={2}>
            <Dashboard />
        </Box>
    );
};